import React, { useEffect, useState } from 'react'
import './styles.scss'
import { CardList, NavigationFilterCardListProps } from './types/NavigationFilterCardList.types'
import {
  Image,
  isEditorActive,
  RichText,
  withSitecoreContext,
  Link,
  Text,
} from '@sitecore-jss/sitecore-jss-react'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

const NavigationFilterCardList = (props: NavigationFilterCardListProps) => {
  const [cardData, setCardData] = useState<CardList[]>([])
  const [selectedLabel, setSelectedLabel] = useState(null)
  const [reSelect, setReSelect] = useState(false)
  const cardListArray = props.fields?.['Cards list']
  const isReadMoreLink = props.params?.['Variation']
  const filterLabels =
    props.fields?.FilterNavData?.fields?.FilterFieldType[0]?.fields?.FilterType
  const searchProps = props.fields?.FilterNavData?.fields?.Value?.value

  useEffect(() => {
    setSelectedLabel(null)
    setReSelect(!reSelect)
  }, [cardListArray])

  useEffect(() => {
    if (filterLabels && filterLabels.length > 0) {
      setSelectedLabel(filterLabels[0].fields.MappingName.value)
    }
  }, [reSelect])

  useEffect(() => {
    if (searchProps == 'Category') {
      if (selectedLabel === '') {
        setCardData(cardListArray ?? []);
      } else {
        const filteredData = cardListArray?.filter((card) => {
          return card.fields?.Category?.value === selectedLabel
        })

        setCardData(filteredData ?? [])
      }
    }

    if (searchProps == 'Date') {
      const filteredDateData = (cardListArray ?? []).filter((card) => {
        if (card?.fields?.Date?.value) {
          const d = new Date(card.fields.Date.value)
          let year = d.getFullYear()
          return year.toString() === selectedLabel;
        }
        return false;
      })

      setCardData(filteredDateData)
    }



  }, [selectedLabel])

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const onFilter = (filterLabel) => {
    setSelectedLabel(filterLabel)
  }

  const getActiveCls = (index, label) => {
    if (!selectedLabel && index === 0) {
      return 'active'
    }
    if (selectedLabel && selectedLabel === label) {
      return 'active'
    }

    return ''
  }

  return (
    <div id={props?.rendering?.uid} className="filternav__barParent">
      <div className="filternav__bar">
        {filterLabels &&
          filterLabels.length > 0 &&
          filterLabels.map((navItem, index) => {
            return (
              <Text
                tag={'span'}
                field={navItem.fields.NavbarLabel}
                key={index}
                onClick={() => {
                  onFilter(navItem.fields.MappingName.value)
                }}
                className={`filternav__bar__label ${getActiveCls(
                  index,
                  navItem.fields.MappingName.value
                )}`}
              ></Text>
            )
          })}
      </div>

      {props.fields && (
        <div className="cardList__wrapper cardList__wrapperA">
          {cardData.map((item, i) => (
            <>
              <div className="cardList_image-wrapper--nav" key={i}>
                <Image
                  loading="lazy"
                  field={item?.fields?.Image}
                  className={'image--desktop--nav'}
                />
                <Image
                  loading="lazy"
                  field={
                    item?.fields?.ImageMobile ?
                      (Object.keys(item?.fields?.ImageMobile?.value ?? []).length > 0
                      ? item?.fields?.ImageMobile
                      : (item?.fields?.AllowFallbackForMobile?.value ?
                      item?.fields?.Image : undefined)) : undefined 
                  }
                  className="image--mobile--nav"
                />
              </div>
              <div className="cardList_content">
                <div className="cardList_date_content">
                  {item?.fields?.TitleIcon && (item?.fields?.TitleIcon?.value?.src?.length ?? 0) > 0 ? (
                    <a href={item?.fields?.TitleLink?.value?.href} className="link--title--nav" target={item?.fields?.TitleLink?.value?.target}>
                      <Image
                        field={
                          item?.fields?.TitleIcon
                        }
                        className="image--title--nav"
                      />
                    </a>

                  ) : (
                    item?.fields?.Category?.value ? (
                      <RichText
                        field={item?.fields?.Category}
                        className="category_tag--nav"
                        tag="p"
                      />
                    ) : null)}
                  {/* {isEditorActive() ? (
                    <Text field={item.fields?.Date} tag="div" />
                  ) : (
                    <Text
                      field={{ value: dateFormat(item.fields?.Date.value) }}
                      tag="span"
                    />
                  )} */}
                  <RichText
                    field={item?.fields?.Content}
                    className="cardList__title"
                    tag="h3"
                  />
                </div>
                <div className="cardList_cta_wrapper">
                  {item?.fields?.['Primary Link']?.value.href ? (
                    <div
                      className={`cta NavigationFilterCardList_cta ${isReadMoreLink}`}
                    >
                      {isEditorActive() ? (
                        <Link field={item?.fields?.['Primary Link']} />
                      ) : (
                        <Link field={item?.fields?.['Primary Link'].value} />
                      )}
                    </div>
                  ) : null}
                  {item.fields?.['Download Link']?.value?.src ? (
                    <a
                      href={anchorWithId(
                        item.fields?.['Download Link']?.value?.src,
                        item.fields?.['Download Link']?.value?.anchor
                      )}
                      download
                      className="download-link"
                    >
                      <Text field={item.fields?.DownloadText} tag="span" />
                      <pfe-icon size={24} icon="cnh-download" />
                    </a>
                  ) : null}
                </div>
              </div>
            </>
          ))}
        </div>
      )}
    </div>
  )
}

export default withSitecoreContext()(NavigationFilterCardList)
